import { render, staticRenderFns } from "./ProductTab.vue?vue&type=template&id=0545c904&scoped=true&"
import script from "./ProductTab.vue?vue&type=script&lang=js&"
export * from "./ProductTab.vue?vue&type=script&lang=js&"
import style0 from "./ProductTab.vue?vue&type=style&index=0&id=0545c904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0545c904",
  null
  
)

export default component.exports